import * as Yup from "yup";

export const bankDetailModalValidationSchema = Yup.object().shape({
  pixKeyType: Yup.string().nullable().required("Forma do Pix é obrigatória"),

  pixKey: Yup.string()
    .nullable()
    .when("pixKeyType", {
      is: (pixKeyType: string | null) =>
        pixKeyType !== "BANK_ACCOUNT" && pixKeyType != null,
      then: (schema) => schema.required("Chave Pix é obrigatória"),
      otherwise: (schema) => schema.nullable(),
    }),

  accountType: Yup.string()
    .nullable()
    .when("pixKeyType", {
      is: "BANK_ACCOUNT",
      then: (schema) => schema.required("Tipo de conta é obrigatório"),
      otherwise: (schema) => schema.nullable(),
    }),

  bankCode: Yup.string()
    .nullable()
    .when("pixKeyType", {
      is: "BANK_ACCOUNT",
      then: (schema) => schema.required("Banco é obrigatório"),
      otherwise: (schema) => schema.nullable(),
    }),

  agency: Yup.string()
    .nullable()
    .when("pixKeyType", {
      is: "BANK_ACCOUNT",
      then: (schema) =>
        schema
          .required("Agência é obrigatória")
          .matches(/^\d{4}$/, "Agência deve ter exatamente 4 dígitos")
          .typeError("Agência deve ser um número"),
      otherwise: (schema) => schema.nullable(),
    }),

  account: Yup.string()
    .nullable()
    .when("pixKeyType", {
      is: "BANK_ACCOUNT",
      then: (schema) =>
        schema
          .required("Número da conta é obrigatório")
          .matches(/^\d+$/, "Número da conta deve conter apenas números")
          .max(11, "Número da conta deve ter no máximo 11 caracteres"),
      otherwise: (schema) => schema.nullable(),
    }),

  accountDigit: Yup.string()
    .nullable()
    .when("pixKeyType", {
      is: "BANK_ACCOUNT",
      then: (schema) =>
        schema
          .required("Dígito é obrigatório")
          .matches(/^\d{1}$/, "Dígito deve ter exatamente 1 número"),
      otherwise: (schema) => schema.nullable(),
    }),
});
